import { IDatasource } from 'core-ts-types';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import { IQuestionBuilderDTD, IStudentAnswerObject } from '../poll_interfaces';

export interface IPollAnswerBuilderDTD {
  id: number;
  value: string;
  question_id: number;
}

export interface IPollAnswerDatastoreDTD {
  answer: IPollAnswerBuilderDTD;
  resource: any;
}

export interface IQuestionAnswerObjectDTD extends IQuestionBuilderDTD {
  choice_values: any[];
  total_answers: number;
}

export class PollAnswerDataStore implements IDatasource {
  id: string;
  store: IPollAnswerDatastoreDTD;

  constructor(private Interface: IInterface, private PollAnswerDatastoreDTD: IInterfaceDTD) {
    this.id = 'pollAnswer';
    this.store = {
      answer: {},
      resource: undefined
    } as IPollAnswerDatastoreDTD;
  }

  write(data: any): PollAnswerDataStore {
    this.store = this.Interface.make(this.PollAnswerDatastoreDTD, data);
    return this;
  }

  add(data: any): PollAnswerDataStore {
    this.store = this.Interface.merge(this.PollAnswerDatastoreDTD, data);
    return this;
  }

  initialize(): PollAnswerDataStore {
    this.store = this.Interface.generate(this.PollAnswerDatastoreDTD);
    return this;
  }

  read(): IPollAnswerDatastoreDTD {
    return this.store;
  }

  report(fn: (store: IPollAnswerDatastoreDTD) => any): any {
    return fn(this.store);
  }

  updateAnswer(answerObj: IStudentAnswerObject): any {
    this.store.answer[answerObj.choiceID] = {
      id: answerObj.choiceID,
      value: answerObj.response,
      question_id: answerObj.questionID
    };
  }
}

export class AnswerBuilderDTO {
  static Interface: IInterface;
  static AnswerBuilderDTD: IInterfaceDTD;
  constructor(data: any) {
    AnswerBuilderDTO.Interface.gateway(AnswerBuilderDTO.AnswerBuilderDTD, data, this);
  }
}

angular
  .module('capability-ng-poll')
  .constant('PollAnswerDatastoreDTD', {
    resource: {
      type: 'object'
    },
    answer: {
      type: 'ngObject',
      typeDef: 'AnswerBuilder'
    }
  })
  .constant('AnswerBuilderDTD', {
    id: 'key',
    value: 'string',
    question_id: 'number'
  })
  .factory('AnswerBuilder', (Interface: IInterface, AnswerBuilderDTD: IInterfaceDTD): any => {
    AnswerBuilderDTO.Interface = Interface;
    AnswerBuilderDTO.AnswerBuilderDTD = AnswerBuilderDTD;
    return AnswerBuilderDTO;
  })
  .factory('ngPollAnswerDataStore', (Interface: IInterface, PollAnswerDatastoreDTD: IInterfaceDTD): any => {
    return new PollAnswerDataStore(Interface, PollAnswerDatastoreDTD).initialize();
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/datastore/poll_answer_datastore.ts